(() => {
  const isPlainPrimaryClick = (event) =>
    event.button === 0 && !event.altKey && !event.ctrlKey && !event.metaKey && !event.shiftKey;

  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || !isPlainPrimaryClick(event)) return;
    if (!(event.target instanceof Element)) return;

    const image = event.target.closest('img');
    if (!image) return;

    // Dawn normally places a transparent button over the entire product
    // image. CSS exposes the real image for the native context menu, so a
    // regular click forwards to the original zoom button.
    const modalOpener = image.closest('modal-opener.product__modal-opener--image');
    if (modalOpener) {
      const zoomButton = modalOpener.querySelector('.product__media-toggle');

      if (zoomButton) {
        event.preventDefault();
        zoomButton.click();
      }

      return;
    }

    // Product cards use a pseudo-element link over the image. Once that
    // overlay is removed for native copy/save, keep ordinary image clicks
    // navigating to the same product page.
    const cardMedia = image.closest('.card__media');
    if (!cardMedia || image.closest('a[href]')) return;

    const card = cardMedia.closest('.card');
    const productLink = card?.querySelector('.card__heading a[href]');

    if (productLink) {
      event.preventDefault();
      productLink.click();
    }
  });
})();
